<template>
  <div>
    <!-- 分享弹窗 开始 -->
    <van-popup 
      v-model="showSharePic" 
      position="bottom"
      round 
      :style="{}"
      class="share_content"
    >
      <div class="share_img_wrap">
        <img :src="shareBase64" >
        <div class="tips_sharepic" v-show="this.$store.state.browser.wx">请长按保存海报图片</div>
        <van-loading type="spinner" class="share_loading" size="50px" vertical color="#ffffff" v-if="!shareBase64">加载中...</van-loading>
 
        <div class="share_bottom_pc" v-if="is_pc">
          <div class="list_share">
            <div class="item_share" @click="copyToClipboard(shareUrl);$toast.success('链接已复制');">
              <div class="cover image"
                v-lazy:background-image="{
                  src: './static/img/share_link.png',
                  error: './static/img/share_link.png'
                }"
              ></div>
              <div class="text">复制链接</div>
            </div>
            <div class="item_share" @click="sharePicDownload">
              <div class="cover image"
                v-lazy:background-image="{
                  src: './static/img/share_down.png',
                  error: './static/img/share_down.png'
                }"
              ></div>
              <div class="text">下载图片</div>
            </div>
          </div>
 
          <div class="bottom_box" @click="showSharePic=false">
            取消
          </div>
        </div>
      </div>
      <vue-qr
        :text="shareUrl"
        :size="200"
        :margin="0"
        colorDark="#222"
        colorLight="#fff"
        :logoSrc="share_logo"
        style="display: none;"
        :callback="qrcodeCallback"
      ></vue-qr>
      <div class="share_bottom" v-if="!is_pc">
        <div class="list_share">
          <div class="item_share" @click="copyToClipboard(shareUrl);$toast.success('链接已复制');">
            <div class="cover image"
              v-lazy:background-image="{
                src: './static/img/share_link.png',
                error: './static/img/share_link.png'
              }"
            ></div>
            <div class="text">复制链接</div>
          </div>
          <div class="item_share" @click="showShareWxTips=true" v-if="this.$store.state.browser.wx">
            <div class="cover image"
              v-lazy:background-image="{
                src: './static/img/share_f.png',
                error: './static/img/share_f.png'
              }"
            ></div>
            <div class="text">发送朋友</div>
          </div>
          <div class="item_share" @click="showShareWxTips=true" v-if="this.$store.state.browser.wx">
            <div class="cover image"
              v-lazy:background-image="{
                src: './static/img/share_wx.png',
                error: './static/img/share_wx.png'
              }"
            ></div>
            <div class="text">发到朋友圈</div>
          </div>
          <div class="item_share" @click="sharePicDownload" v-if="(!this.$store.state.browser.wx && !this.$store.state.browser.ios) && !this.$store.state.browser.giantopoapp">
            <div class="cover image"
              v-lazy:background-image="{
                src: './static/img/share_down.png',
                error: './static/img/share_down.png'
              }"
            ></div>
            <div class="text">下载图片</div>
          </div>
        </div>
 
        <div class="bottom_box" @click="showSharePic=false">
          取消
        </div>
      </div>
    </van-popup>
    <!-- 分享弹窗 结束 -->
 
     <!-- 微信提示分享 开始 -->
      <van-popup
        v-model="showShareWxTips"
        round
        position="top"
        id="subplate_sharewxtips"
        :close-on-popstate="true"
        @click.native="showShareWxTips=false"
      >
        <img src="~@/assets/img/sharetips.png">
      </van-popup>
      <!-- 微信提示分享 结束 -->
  </div>
</template>
 
<script>
import vueQr from 'vue-qr'
 
 
export default {
  name: 'Share',
  components: {
    vueQr
  },
  props: ['share_info'],
  data () {
    return {
      showSharePic: false, //分享弹窗显示
      shareBase64: '',//最终生成海报的Base64
      shareUrl: '',
      //分享海报配置
      share_logo: './static/img/logo_gra_1.png',
      share_margin: 5,
      share_color: '#ffffff',
      shareSrcList: [
        {
          type: 'pic',
          name: '头图',
          file: '',//'http://192.168.3.110:8080/static/img/color_05.png',
          size: [0, 0, 640]
        },
        {
          type: 'pic',
          name: '二维码',
          file: '',
          size: [390, 445, 225, 225]
        },
        // {
        //   type: 'pic',
        //   name: 'LOGO',
        //   file: this.$store.state.externalurl.GIANT_CDN + '/img/logo.png',
        //   size: [1000, 1000],//[25, 845]//因为运营要求隐藏LOGO，就把它暂扔到天外
        // },
        {
          type: 'text',
          name: '标题',
          text: '',
          size: [25, 665]//[25, 665]
        }
      ],
 
      showShareWxTips: false,//显示微信分享提示
 
      share_data: {},
      is_pc: false,
    }
  },
  computed: {},
  watch: {
    
  },
  beforeRouteEnter(to, from, next) {  
  },
  created() {
    const _this = this;
    if( !_this.$store.state.IS_COMPUTER ){
      _this.is_pc = true;
    }
 
    _this.share_data = _this.share_info;
    
    _this.shareUrl = _this.share_data.url;
    _this.shareSrcList[0].file = _this.share_data.img;
    _this.shareSrcList[2].text = _this.share_data.name;
  },
  mounted() {
    const _this = this;
  },
  destroyed() {
    const _this = this;
  },
  methods: {
    //（切换）弹出面板
    showPopup() {
      const _this = this;
 
      _this.showSharePic = !_this.showSharePic;
    },
    //============= 海报 开始 ==========================
    //二维码生成后
    qrcodeCallback(data){
      const _this = this;
      _this.shareSrcList[1].file = data;
      
      _this.sharePicDraw(_this.shareSrcList, function(data){
        _this.shareBase64 = data;
      });
    },
 
    //生成海报
    sharePicDraw(_list, callback){
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext("2d");
 
      //设置canvas宽高
      canvas.width = 640; 
      canvas.height = 740;
      ctx.rect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#fff'; // 填充颜色
      ctx.fill();
 
      // 开始绘画
      let drawing = (_list, _index) => {
        //判断当前索引 =》 是否已绘制完毕
        if (_index < _list.length) {
          if( _list[_index].type == 'text' ){//写文字
 
            ctx.fillStyle = "#222";
            ctx.font = "bolder 35px Arial,Microsoft Yahei,sans-serif";
            ctx.shadowBlur = 3;
            ctx.shadowColor = "rgba(0,0,0,.2)";
            ctx.textAlign = "start";
            ctx.textBaseline="top";
 
            var str = _list[_index].text;
            // var initX = _list[_index].size[0];
            // var initY = _list[_index].size[1];
 
            var initX = _list[_index].size[0];
            var initY = 445;
            
            var nowY = initY;
            var lineHeight = 50;
            var lineWidth = 0;
            var canvasWidth = 340;//350
            var lastSubStrIndex= 0;
            var tmp_linecounter = 0;
            var ellipsis = 75;//120
 
            for(var i=0;i<str.length;i++){
              lineWidth += ctx.measureText(str[i]).width;
 
              if( initY + (lineHeight * 3) < nowY + lineHeight ) {
                break;
              } else if( initY + (lineHeight * 3) == nowY + lineHeight ) {
                if(lineWidth + ellipsis > canvasWidth - initX){//减去initX,防止边界出现的问题
                  ctx.fillText(str.substring(lastSubStrIndex,i) + "…",initX,nowY);
                  ctx.strokeText(str.substring(lastSubStrIndex,i) + "…",initX,nowY);
                  nowY+=lineHeight;
                  lineWidth=0;
                  lastSubStrIndex=i;
                } else {
                  if(i==str.length-1){
                    ctx.fillText(str.substring(lastSubStrIndex,i+1),initX,nowY);
                    ctx.strokeText(str.substring(lastSubStrIndex,i+1),initX,nowY);
                    //break;
                  }
                }
              } else {
              
                if(lineWidth > canvasWidth - initX){//减去initX,防止边界出现的问题
                  ctx.fillText(str.substring(lastSubStrIndex,i+1),initX,nowY);
                  ctx.strokeText(str.substring(lastSubStrIndex,i+1),initX,nowY);
                  nowY+=lineHeight;
                  lineWidth=0;
                  lastSubStrIndex=i+1;
                } else {
                  if(i==str.length-1){
                    ctx.fillText(str.substring(lastSubStrIndex,i+1),initX,nowY);
                    ctx.strokeText(str.substring(lastSubStrIndex,i+1),initX,nowY);
                  } else {
                    
                  }
                }
              }
            }
 
            drawing(_list, _index + 1);
          } else {//图片
            // 等图片预加载后画图
            let img = new Image();
            let timeStamp = new Date().getTime();
            //防止跨域
            img.setAttribute('crossOrigin', 'anonymous');
            //链接加上时间戳
            img.src = _list[_index].file;// + '?' + timeStamp
            //console.log(_list[_index].size)
            img.onload = function() {
              //画图
              if( _list[_index].size[2] != null && _list[_index].size[3] == null ){
 
                _list[_index].size[3] = _list[_index].size[2] * img.height / img.width;
 
              } else if( _list[_index].size[3] != null && _list[_index].size[2] == null ){
 
                _list[_index].size[2] = _list[_index].size[3] * img.width / img.height;
 
              }
              ctx.drawImage(img, ..._list[_index].size)
              // 递归_list
              drawing(_list, _index + 1);
            }
          }
        } else {
          // 生成图片
          let shareBase64 = canvas.toDataURL("image/png")
          
          if (shareBase64) {
            //console.log(shareBase64);
            if( typeof callback == 'function' ){
              callback(shareBase64);
            }
          }
        }
      }
 
      drawing(_list, 0);
 
    },
 
    //下载已合成的二维码
    sharePicDownload() {
      const _this = this;
 
      if( !_this.shareBase64 ){
        _this.$toast.fail('图片正在加载中，请稍后再试');
        return false;
      }
 
      if (_this.$store.state.browser.giantopoapp) {
        if (_this.$store.state.browser.ios) {
          window.webkit.messageHandlers.download.postMessage(this.shareBase64)
        } else {
          android.download(this.shareBase64);
        }
      } else {
        var a = document.createElement('a');
        a.download = '二维码_' + (new Date().getTime()) + '.png';//下载图名字
        a.href = this.shareBase64; // url
        a.dispatchEvent(new MouseEvent('click'));//合成函数，执行下载
      }
      
      
    
    },
  }
}
</script>
 
 
<style lang="less">
 
</style>
<style lang="less" scoped>
 
 
</style>



// WEBPACK FOOTER //
// src/components/share.vue